import {register} from '@shopify/theme-sections';
import Swiper from 'swiper/bundle';

register('most-loved-blog-posts', {
  onLoad() {
    this.init();
  },

  init() {
    this.cleanSlide(this.id);
  },

  cleanSlide(id) {
    const target = `.most-loved-blog-posts--${id}`;
    new Swiper(target, {
      slidesPerView: 2,
      loop: true,
      spaceBetween: 210,
      centeredSlides: true,
      navigation: {
        nextEl: `.swiper-button-next--${id}`,
        prevEl: `.swiper-button-prev--${id}`,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: 'true',
      },
      breakpoints: {
        300: {
          slidesPerView: 1,
          spaceBetween: 0,
          centeredSlidesBounds: true,
          freeModeSticky: true,
        },
        767: {
          slidesPerView: 2,
          spaceBetween: 30,
          centeredSlides: false,
        },
        1023: {
          slidesPerView: 3,
          spaceBetween: 40,
          centeredSlides: false,
        },
      },
    });
  },
});
